import React, { useEffect } from "react";
import { Table, Space, Switch, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCustomerModel } from "../baseCustomerModel";
import { IVRMCustomerDetail } from "../baseCustomerService";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";



export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, onDisabled, loadCustomerAllData
    } = useCustomerModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    useEffect(() => {
        loadCustomerAllData()
        loadData()
    }, []);
    const columns: ColumnsType<IVRMCustomerDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`

        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 200,
            ellipsis: true,
            dataIndex: 'name',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            // title: '联系人',
            title: Locale["Contact"],
            width: 100,
            dataIndex: 'contact',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 100,
            dataIndex: 'phone',
        }, {
            // title: '客户类型',
            title: Locale["Customer Type"],
            width: 120,
            dataIndex: 'categoryCode',
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text && !!getTreeNodeOne(text)) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '客户地址',
            title: Locale["Address"],
            width: 200,
            dataIndex: 'address',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '创建人',
            title: Locale["Founder"],
            width: 100,
            dataIndex: 'createUser',
        }, {
            // title: '创建时间',
            title: Locale["Founder Time"],
            width: 200,
            dataIndex: 'createTime',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 100,
            dataIndex: 'note',
        }, {
            // title: '操作',
            title: Locale["Operation"],
            width: 100,
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={text == 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            ),
        }
    ];
    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id as string]);
        }
    };
    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IVRMCustomerDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
